import {PureComponent} from 'react'
import {Field, reduxForm} from 'redux-form'

import Date from '../../Form/Field/Date.jsx'
import normBoolean from "../../Form/Normalizer/boolean.js"
import CardCol from "../../Styled/Dasboard/CardCol.jsx"
import CardRow from "../../Styled/Dasboard/CardRow.jsx"
import Toggle from "../../Form/Field/Toggle.jsx"
import connectModal from "../../Modals/connect.js"
import ConfirmModal from "../../Modals/ConfirmModal/ConfirmModal.jsx"

import './FreelanceDashboardAvailabilityForm.scss'

export const name = 'FreelanceDashboardAvailabilityForm'

class FreelanceDashboardAvailabilityForm extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      shouldResetForm: false,
    }
  }
  initialiseForm = () => {
    this.props.reset()
  }

  confirmModal = (confirmAction) => {
    this.props.openConfirmModal({
      header: 'Masquer votre profil',
      body: 'Êtes-vous sûr(e) de vouloir masquer votre profil ? Bien entendu, vous pourrez à nouveau qualifier votre profil en public par la suite.',
      confirmText: 'Confirmer',
      cancelText: 'Annuler',
      confirmAction: confirmAction,
      onCancel: () => this.setState({shouldResetForm: true}),
    })
  }
  componentDidUpdate(prevProps, prevState, prevContext) {
    if(prevState.shouldResetForm !== this.state.shouldResetForm && !!this.state.shouldResetForm){
      this.initialiseForm()
      this.setState({shouldResetForm: false})
    }
  }

  onFreelancePublicChange = (event, value) => {
    this.confirmModal(() => this.props.handlePublicVisibilityChange(event, value)
      .then((response) => {
        if(false === response) {
          this.initialiseForm()
        }})
    )
  }

  handleDateChange = (value, isoStrDate) => {
    this.props.handleDateChange(isoStrDate)
  }

  render() {
    return (
      <div id={name} className="freelance-dashboard-availability-form">
        <form
          autoComplete="off"
          onSubmit={(e) => {
            return
          }}
        >
          <CardRow>
            <CardCol>
              <label htmlFor="">Date de disponibilité :</label>
              <Field
                label={null}
                name="freelance.date_available"
                placeholder="JJ/MM/AAAA"
                type="text"
                component={Date}
                onChange={this.handleDateChange}
              />
            </CardCol>
            <CardCol>
              <label htmlFor="">Mon profil est :</label>
              <Field
                name={`freelance.public`}
                firstLabel={'Masqué'}
                secondLabel={'Visible'}
                disabled={false}
                normalize={normBoolean}
                component={Toggle}
                onChange={this.onFreelancePublicChange}
              />
            </CardCol>
          </CardRow>
        </form>
      </div>
    )
  }
}

let ReduxFreelanceDashboardAvailabilityForm = reduxForm({
  form: name,
})(FreelanceDashboardAvailabilityForm)

export default connectModal({ConfirmModal}, ReduxFreelanceDashboardAvailabilityForm)
